import axiosInstance from "../config/axiosConfig";

export const uploadImage = async (body) => {
    return await axiosInstance.post("/api/upload/image", body, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};
